export default class VehicleGraphicPool {
  private pool: __esri.Graphic[] = [];
  private Graphic: __esri.GraphicConstructor;
  private layer: __esri.GraphicsLayer;
  private models: {
    href: string;
    width: number;
    height: number;
    depth: number;
  }[];

  constructor(
    models: { href: string; width: number; height: number; depth: number }[],
    Graphic: __esri.GraphicConstructor,
    layer: __esri.GraphicsLayer,
    poolSize: number = 30
  ) {
    this.models = models;
    this.Graphic = Graphic;
    this.layer = layer;

    for (let i = 0; i < poolSize; i++) {
      const model = models[i % models.length];
      const graphic = new Graphic({
        geometry: {
          type: "point",
          x: 0,
          y: 0,
        } as any,
        symbol: {
          type: "point-3d",
          symbolLayers: [
            {
              type: "object",
              width: model.width,
              height: model.height,
              depth: model.depth,
              anchor: "origin",
              resource: { href: model.href },
            },
          ],
        } as any,
        attributes: {
          spawned: false,
        },
      });

      this.pool.push(graphic);
    }
    this.layer.addMany(this.pool);
  }

  public fetch(): __esri.Graphic {
    const notSpawned = this.pool.filter(
      (graphic) => !graphic.attributes["spawned"]
    );
    if (notSpawned.length > 0) {
      const graphic = notSpawned[Math.floor(Math.random() * notSpawned.length)];
      graphic.attributes["spawned"] = true;
      return graphic;
    }

    // 模型池的所有模型都已用完，新生成一个
    const model = this.models[Math.floor(Math.random() * this.models.length)];
    const graphic = new this.Graphic({
      geometry: {
        type: "point",
        x: 0,
        y: 0,
      } as any,
      symbol: {
        type: "point-3d",
        symbolLayers: [
          {
            type: "object",
            width: model.width,
            height: model.height,
            depth: model.depth,
            anchor: "origin",
            resource: { href: model.href },
          },
        ],
      } as any,
      attributes: {
        spawned: true,
      },
    });
    this.pool.push(graphic);
    return graphic;
  }

  public destroy() {
    this.layer.removeMany(this.pool);

    this.pool = [];
  }
}
